// 🎨 Jetons de la charte du nouveau design (tour 31), en variables CSS « --nd-… ». Valeur claire et
// valeur sombre pour les couleurs qui changent avec le thème ; les autres sont les mêmes dans les
// deux. Posées par NewDesign.js (classe « nd » sur <body>).
// ☀️ Thème clair en blanc chaud (tour 43, maquette « blanc chaud » de l'accueil) : fonds, traits,
// ombres et texte secondaire chauds ; sur les fonds clairs, le bleu clair #a5daed devient le bleu
// canard #6fb0ba (#4c949f pour ce qui porte une information : données des graphes, contour du
// focus, contraste 3:1). Les cartes restent blanches.
// 🌙 Thème sombre en gris chauds (tour 49, maquette validée par Flo) : fonds, cartes, panneaux, textes,
// traits, quadrillage et axes passent des gris neutres à des gris chauds, les courbes à #2f8691. Le
// bleu clair #a5daed reste pour les accents. Gris dérivés (chargement, squelettes) réchauffés pareil.
export const COLORS = {
  "marque-noir": "#1e1e1e",
  "marque-gris": "#2d2d2d",
  "marque-bleu": "#076f7e",
  "marque-orange": "#f99308",
  "marque-bleu-clair": "#a5daed",
  fond: { light: "#fffcf7", dark: "#1f1c1a" },
  "fond-page": { light: "#f8f3ea", dark: "#171513" },
  // Bandes, panneaux et champs (valeurs des maquettes de l'accueil)
  bande: { light: "#fbf6ee", dark: "#171513" },
  panneau: { light: "#fbf7f0", dark: "#26221f" },
  champ: { light: "#f7f1e7", dark: "#1f1c1a" },
  "champ-bord": { light: "#eadfcd", dark: "rgba(255, 236, 210, 0.12)" },
  surface: { light: "#ffffff", dark: "#2a2623" },
  texte: { light: "#1e1e1e", dark: "#ece6de" },
  "texte-doux": { light: "#5c5750", dark: "#bdb4a9" },
  trait: { light: "rgba(70, 50, 20, 0.10)", dark: "rgba(255, 236, 210, 0.12)" },
  "trait-fort": { light: "rgba(70, 50, 20, 0.18)", dark: "rgba(255, 236, 210, 0.24)" },
  ombre: { light: "rgba(90, 60, 20, 0.10)", dark: "rgba(0, 0, 0, 0.45)" },
  lien: { light: "#076f7e", dark: "#a5daed" },
  // Texte bleu posé sur le bleu doux (badges, pastilles, aperçu) : plus foncé en clair, pour 4,5:1
  // même sur les sections grises (tour 43) ; inchangé en sombre
  "lien-fonce": { light: "#055c69", dark: "#a5daed" },
  action: "#f99308",
  "action-survol": "#e48600",
  "action-desactive": "#f9c27a",
  "action-texte": "#1e1e1e",
  secondaire: "#076f7e",
  "secondaire-survol": "#055c69",
  // Texte sur le bleu (boutons secondaires, choix faits, cases du planning) : blanc, contraste 5,9
  "secondaire-texte": "#ffffff",
  "bleu-doux": { light: "rgba(111, 176, 186, 0.25)", dark: "rgba(165, 218, 237, 0.18)" },
  // Bleu clair des fonds clairs (courbes, onglets, badges, bordures) ; sur les fonds foncés (pied de
  // page, bandeaux bleu foncé), marque-bleu-clair reste #a5daed
  "bleu-clair": { light: "#6fb0ba", dark: "#a5daed" },
  // Ce qui porte une information (barre, point, ligne de données) : 3:1 sur les fonds clairs
  donnee: { light: "#4c949f", dark: "#a5daed" },
  // Contour du focus au clavier : 3:1 sur les fonds clairs
  focus: { light: "#4c949f", dark: "#a5daed" },
  "orange-doux": "rgba(249, 147, 8, 0.12)",
  "orange-texte": { light: "#995600", dark: "#f9b24f" },
  "vert-doux": "rgba(25, 135, 84, 0.12)",
  "vert-texte": { light: "#146c43", dark: "#6fd3a1" },
  "en-ligne": "#22c55e",
  danger: "#c0392b",
  quadrillage: { light: "#f1e8da", dark: "rgba(240, 214, 178, 0.065)" },
  courbe: { light: "#6fb0ba", dark: "#2f8691" },
  formule: { light: "rgba(7, 111, 126, 0.40)", dark: "rgba(165, 218, 237, 0.45)" },
  "ombre-carte": { light: "0 2px 12px rgba(90, 60, 20, 0.10)", dark: "0 2px 12px rgba(30, 30, 30, 0.35)" },
  // Deuxième trait et axe de la signature : valeurs de la maquette Recherche.html, pas encore
  // dans tokens.json
  courbe2: { light: "rgba(7, 111, 126, 0.45)", dark: "rgba(165, 218, 237, 0.55)" },
  axe: { light: "#d8cab3", dark: "rgba(240, 214, 178, 0.28)" },
  // États (chargement, listes qui chargent, erreur) : valeurs de la maquette Etats.html, pas encore
  // dans tokens.json
  "livre-couverture": { light: "#076f7e", dark: "#16626e" },
  "livre-page": { light: "#ffffff", dark: "#322d29" },
  "livre-ligne": { light: "#eadfcd", dark: "#4f4740" },
  "livre-grille": { light: "#f1e8da", dark: "rgba(240, 214, 178, 0.075)" },
  "livre-ombre": { light: "rgba(90, 60, 20, 0.10)", dark: "rgba(0, 0, 0, 0.45)" },
  "squelette-1": { light: "#f1e8da", dark: "#37312c" },
  "squelette-2": { light: "#fbf7f0", dark: "#423b35" },
  "rouge-doux": { light: "rgba(192, 57, 43, 0.10)", dark: "rgba(192, 57, 43, 0.22)" },
  "danger-texte": { light: "#c0392b", dark: "#f19a8f" },
  "toast-ombre": { light: "rgba(90, 60, 20, 0.10)", dark: "rgba(0, 0, 0, 0.45)" },
  // Point « hors ligne » de l'en-tête des espaces
  "hors-ligne": { light: "#a39a8d", dark: "#a39a8d" },
};

// Tailles de texte, en « --nd-taille-… » (le jeton couleur « formule » porte le même nom)
export const TYPE = {
  "titre-accueil": "36px",
  "titre-page": "28px",
  "titre-section": "22px",
  "titre-carte": "17.6px",
  "texte-courant": "15.2px",
  "texte-petit": "14px",
  etiquette: "13.6px",
  formule: "17px",
};

// Mêmes valeurs dans les deux thèmes
export const SIZES = {
  "espace-1": "4px",
  "espace-2": "8px",
  "espace-3": "12px",
  "espace-4": "16px",
  "espace-5": "20px",
  "espace-6": "24px",
  "espace-10": "40px",
  "rayon-sm": "10px",
  "rayon-md": "12px",
  "rayon-lg": "16px",
  "rayon-pilule": "999px",
  // Repli à la largeur de Poppins tant qu'elle charge (NewDesignStyle, tour 38) : Arial, sinon Roboto
  "police-titre": "Poppins, 'Poppins repli', 'Poppins repli Roboto', system-ui, sans-serif",
  "police-texte": "Roboto, system-ui, sans-serif",
  "police-formule": "'Courier New', ui-monospace, monospace",
};

// Sur téléphone (jusqu'à 575 px), les deux grands titres rapetissent
export const PHONE_SIZES = { "titre-accueil": "22px", "titre-page": "23px" };

const valueFor = (value, theme) => (typeof value === "string" ? value : value[theme]);

// { "--nd-fond": "#ffffff", … } : les couleurs en style d'un élément, pour ce qui s'affiche avant les
// styles communs (écran du premier chargement, tour 34)
export const colorVariables = (theme) => Object.fromEntries(Object.entries(COLORS).map(([name, value]) => [`--nd-${name}`, valueFor(value, theme)]));

// « --nd-fond: #ffffff; … » pour le thème demandé ("light" ou "dark")
export const cssVariables = (theme) =>
  Object.entries(COLORS)
    .map(([name, value]) => `--nd-${name}: ${valueFor(value, theme)};`)
    .concat(theme === "light" ? Object.entries(TYPE).map(([name, value]) => `--nd-taille-${name}: ${value};`) : [])
    .concat(theme === "light" ? Object.entries(SIZES).map(([name, value]) => `--nd-${name}: ${value};`) : [])
    .join("\n");
